import React from "react";
import ReactDOM from "react-dom";

// v=2 forces the browser to fetch the latest pricing.html; change to v=3 etc. after editing that page
const UPGRADE_EMBED_URL = "https://invoice.vsmartengine.com/pricing.html?embed=true&v=2";

const UpgradePlansModal = ({ show, onClose }) => {
  if (!show) return null;

  // Rendered on document.body so the header/sidebar can never hide it
  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.6)",
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 12,
          width: "100%",
          maxWidth: 820,
          height: "90vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 20px",
            borderBottom: "1px solid #eef0f3",
          }}
        >
          <strong>Upgrade Plan</strong>
          <button
            onClick={onClose}
            style={{ border: "none", background: "transparent", fontSize: 24, lineHeight: 1, cursor: "pointer" }}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <iframe
          src={UPGRADE_EMBED_URL}
          title="Invoice Pricing Plans"
          style={{ flex: 1, width: "100%", border: "none" }}
        />
      </div>
    </div>,
    document.body
  );
};

export default UpgradePlansModal;